import React from 'react';
import Square from './Square';
import './Board.css';

const Tictactoe = ({board, updateBoard, winner, keepPlaying}) => {
  const selectSquare = (x, y) => {
    updateBoard(x, y);
  };
  
  var winnerText = '';
  if (keepPlaying == false) {
    if (winner) {
      winnerText = `The winner is: ${winner} !`;
    } else {
      winnerText = `That was a TIE!`;
    }
  }

  return (
    <div >
      <div className="status"> 
        <p>{winnerText}</p>
      </div>
      <div className="board-row">
        <Square value={board[0][0]} selectSquare={selectSquare} x={0} y={0}/>
        <Square value={board[0][1]} selectSquare={selectSquare} x={0} y={1}/>
        <Square value={board[0][2]} selectSquare={selectSquare} x={0} y={2}/>
      </div>
      <div className="board-row">
        <Square value={board[1][0]} selectSquare={selectSquare} x={1} y={0}/>
        <Square value={board[1][1]} selectSquare={selectSquare} x={1} y={1}/>
        <Square value={board[1][2]} selectSquare={selectSquare} x={1} y={2}/>
      </div>
      <div className="board-row">
        <Square value={board[2][0]} selectSquare={selectSquare} x={2} y={0}/>
        <Square value={board[2][1]} selectSquare={selectSquare} x={2} y={1}/>
        <Square value={board[2][2]} selectSquare={selectSquare} x={2} y={2}/>
      </div>
    </div>
  )
}

export default Tictactoe;